import { observer } from "mobx-react";
import { Button } from "primereact/button";
import { Column, ColumnProps } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { RefObject } from "react";
import { RouterProps } from "react-router";
import { Flex } from "reflexbox";
import ReactFileReader from 'react-file-reader';
import { Dialog } from 'primereact/dialog';
import { Growl } from 'primereact/growl';

import { DataSource } from "../../models/DataSource";
import { observable } from 'mobx';
import { DataTableFilterService } from "../../services/DataTableFilterService";
import { MonitoringRestService } from "../../services/MonitoringRestService";
import { DependencyContainer } from "../../utils/DependencyInjection";
import {
  IMonitoringFeeDetailFilterContainerValue,
  MonitoringFeeDetailFilterContainer,
} from "./MonitoringFeeDetailFilterContainer";
import _ from "lodash";
import { Observable } from "rxjs";
import qs from "qs";
import { Link } from "react-router-dom";
import moment from "moment";

export interface IMonitoringFeeDetailParamContainerValue {
  startDate?:any;
  endDate?: any;
  perwakilan?: any;
  branch?: any;
}
export interface IMonitoringFeeDetailParamContainerQuery {
  representativeId?: any;
  branchId?: any;
  filters: IMonitoringFeeDetailParamContainerValue;
}

@observer
export class MonitoringFeeDetailContainer extends React.Component<RouterProps, any> {
  dataTableFilterService = DependencyContainer.get(DataTableFilterService);
  monitoringRestService = DependencyContainer.get(MonitoringRestService);

  @observable data;
  growl;
  tableExportData;
  userData;
  dataSource = new DataSource<any>();
  formFilters: IMonitoringFeeDetailFilterContainerValue;
  queryParameters: IMonitoringFeeDetailParamContainerQuery;
  refFilter: RefObject<MonitoringFeeDetailFilterContainer> = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      showExportDialog: false,
      showDialog: false,
    };

    this.userData = localStorage.getItem("userData")
      ? JSON.parse(localStorage.userData)
      : null;

    this.exportCsv = this.exportCsv.bind(this);
  }

  componentWillMount() {
    this.queryParameters = qs.parse(
      this.props.history.location.search.substr(1),
    ) as any;

    console.log(this.queryParameters);
    const params = {
      startDate: this.queryParameters.filters.startDate,
      endDate: this.queryParameters.filters.endDate,
      perwakilan: this.queryParameters.representativeId,
      branch: this.queryParameters.branchId,
      titleName: '',
      category: '',
    }
    console.log(params);
    this.dataSource.loading = true;
    this.monitoringRestService.post("monitoring-penalty/detail/list", params).subscribe(
      (response) => {
        console.log(response);
        this.data = response;
        this.dataSource.setData(this.data);
        this.dataSource.setTotal(this.data.length);
      },
      () => {
        this.dataSource.loading = false;
      },
      () => {
        this.dataSource.loading = false;
      }
    );
  }

  loadData() {
    this.formFilters = this.refFilter.current!.formValues;
    const params = {
      startDate: this.queryParameters.filters.startDate,
      endDate: this.queryParameters.filters.endDate,
      perwakilan: this.queryParameters.representativeId,
      branch: this.queryParameters.branchId,
      titleName: this.formFilters.titleName,
      category: this.formFilters.category,
    }
    this.dataSource.loading = true;
    this.monitoringRestService.post("monitoring-penalty/detail/list", params).subscribe(
      (response) => {
        console.log(response);
        this.data = response;
        this.dataSource.setData(this.data);
        this.dataSource.setTotal(this.data.length);
      },
      () => {
        this.dataSource.loading = false;
      },
      () => {
        this.dataSource.loading = false;
      }
    );
  }

  exportCsv() {
    this.tableExportData.exportCSV();
    let msg = {
      severity: "success",
      summary: "Success Message",
      detail: "Export Success",
    };
    this.growl.show(msg);
  }

  render() {
    return (
      <div>
        <Dialog
          header="Informasi"
          visible={this.state.showExportDialog}
          style={{ width: "40vw" }}
          modal={true}
          onHide={() => this.setState({ showExportDialog: false })}
        >
          Export excel sedang berjalan, mohon jangan tinggalkan halaman ini
        </Dialog>

        <Dialog header="Informasi" visible={this.state.showDialog} style={{ width: '40vw' }} modal={true} onHide={() => this.setState({ showDialog: false })}>
          Sedang memuat data, mohon jangan tinggalkan halaman ini
        </Dialog>

        <Growl ref={(el) => (this.growl = el)} style={{ marginTop: "75px" }} />

        <Flex className="card w-full">
          <Flex className="w-full" column>
            <MonitoringFeeDetailFilterContainer ref={this.refFilter} />
            <br />
            <Flex>
              <Link
                to={{
                  pathname: "/admin/monitoring/pod-fee",
                  search: qs.stringify({
                    filters: this.formFilters,
                  }),
                }}
              >
                <Button
                  className="p-button-info mr-2"
                  label="Kembali"
                  onClick={() => this.loadData()}
                />
              </Link>
              <Button
                className="p-button-success mr-2"
                label="Tampilkan"
                onClick={() => this.loadData()}
              />
              <Button
                type="button"
                className="p-button-primary mr-2"
                icon="pi pi-external-link"
                iconPos="left"
                label="CSV"
                onClick={this.exportCsv}
              ></Button>
            </Flex>
          </Flex>
        </Flex>

        <Flex className="card w-full">
          <Flex className="w-full" column>
            <div className="col-md-12">
              <DataTable
                emptyMessage={"Tidak ada data untuk ditampilkan."}
                scrollable={true}
                scrollHeight="365px"
                className="mt-4"
                value={this.dataSource.data}
                loading={this.dataSource.loading}
                paginator={true}
                rows={50}
                rowsPerPageOptions={[5, 10, 20, 50, 100]}
                ref={(el) => {
                  this.tableExportData = el;
                }}
              >
                <Column
                  field="penaltyDateTime"
                  header="Tanggal"
                  sortable={true}
                  style={{ width: "130px" }}
                  body={(rowData, column: ColumnProps) => {
                    const colValue = rowData[column.field!];
                    const fmtValue = colValue ? moment(new Date(colValue)).utc().format('DD-MM-YYYY HH:mm') : '-';
                    return <span>{fmtValue}</span>;
                  }}
                />
                <Column
                  field="employeeRoleName"
                  header="Jabatan"
                  filter={true}
                  filterMatchMode="contains"
                  sortable={true}
                  style={{ width: "130px" }}
                  body={(rowData, column: ColumnProps) => {
                    const colValue = rowData[column.field!] + " (" + rowData.employeeRoleCode + ")";
                    const fmtValue = colValue ? colValue.toLocaleString() : "-";
                    return <span>{fmtValue}</span>;
                  }}
                />
                <Column
                  field="firstName"
                  header="Nama"
                  filter={true}
                  filterMatchMode="contains"
                  sortable={true}
                  style={{ width: "130px" }}
                />
                <Column
                  field="penaltyCategoryTitle"
                  header="Kategori"
                  filter={true}
                  filterMatchMode="contains"
                  sortable={true}
                  style={{ width: "130px" }}
                />
                <Column
                  field="refAwbNumber"
                  header="No Resi"
                  sortable={true}
                  style={{ width: "130px" }}
                  body={(rowData, column: ColumnProps) => {
                    const colValue = rowData[column.field!];
                    const fmtValue = colValue ? colValue.toLocaleString() : "-";
                    return <span>{fmtValue}</span>;
                  }}
                />
                <Column
                  field="refSpkCode"
                  header="No SPK"
                  sortable={true}
                  style={{ width: "130px" }}
                  body={(rowData, column: ColumnProps) => {
                    const colValue = rowData[column.field!];
                    const fmtValue = colValue ? colValue.toLocaleString() : "-";
                    return <span>{fmtValue}</span>;
                  }}
                />
                <Column
                  field="totalPenalty"
                  header="Total Denda"
                  sortable={true}
                  style={{ width: "130px" }}
                  body={(rowData, column: ColumnProps) => {
                    const colValue = rowData[column.field!];
                    const fmtValue = colValue ? colValue.toLocaleString() : "-";
                    return <span>{fmtValue}</span>;
                  }}
                />
                <Column
                  field="penaltyNote"
                  header="Sanksi"
                  sortable={true}
                  style={{ width: "130px" }}
                />
                <Column
                  field="desc"
                  header="Keterangan"
                  sortable={true}
                  style={{ width: "130px" }}
                />
              </DataTable>
            </div>
          </Flex>
        </Flex>
        
      </div>
    );
  }
}
